module.exports = __webpack_public_path__ + "img/neweRLogo.773cdd12.png";